import { render, staticRenderFns } from "./SurveyChapStruct2.vue?vue&type=template&id=069cd9fb&"
import script from "./SurveyChapStruct2.vue?vue&type=script&lang=js&"
export * from "./SurveyChapStruct2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports